<app-progress-bar *ngIf="loading"></app-progress-bar>
<div *ngIf="!loading" class="row mt-1">
    <div class="col-lg-4 offset-lg-4">
        <div class="card  mb-3" style="max-width: 25rem;">
            <div class="card-header text-center">{{ operacion }} Inscripción</div>
            <div class="card-body">
                <form [formGroup]="form" (ngSubmit)="addAreaCenter()">
                    <table class="table">
                        <thead class="bg-primary  text-white">
                            <tr>
                                <th>ID</th>
                                <th>Nombre</th>
                            </tr>
                        </thead>
                        <tbody >
                            <tr *ngFor="let center of centers" [class.selected]="center.id === form.get('idcenter')?.value" (click)="selectCenter(center)">
                                <td>{{ center.id }}</td>
                                <td>{{ center.name }}</td>
                            </tr>
                            
                        </tbody>
                    </table>
                    <table class="table mt-2">
                        <thead class="bg-primary  text-white">
                            <tr>
                                <th>ID</th>
                                <th>Nombre</th>
                                <th>Estado</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let area of areas" [class.selected]="area.id === form.get('idarea')?.value" (click)="selectArea(area)">
                                <td>{{ area.id }}</td>
                                <td>{{ area.name }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table">
                        <thead class="bg-primary  text-white">
                            <tr>
                                <th>ID</th>
                                <th>Nombre</th>
                            </tr>
                        </thead>
                        <tbody >
                            <tr *ngFor="let turn of turns" [class.selected]="turn.id === form.get('idturn')?.value" (click)="selectTurn(turn)">
                                <td>{{ turn.id }}</td>
                                <td>{{ turn.name }}</td>
                            </tr>
                            
                        </tbody>
                    </table>

                    <div class="row mt-2 text-center">
                        <div class="col-lg-6">
                            <button routerLink="/areacenter" type="button" class="btn btn-secondary">Volver</button>
                        </div>
                        <div class="col-lg-6">
                            <button [disabled]="form.invalid" type="submit" class="btn btn-primary">Aceptar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
